import React from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
const BasicDetails = ({ dataList, PersonalList, getprofile }) => {
  return (
    <div>
      <Form>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">First Name</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="Name"
                defaultValue={dataList?.user?.first_name || "Rajesh"}
                readOnly
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Last Name</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="Name"
                defaultValue={dataList?.user?.last_name || "Kumar"}
                readOnly
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Email Address</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="edushala@edushala"
                defaultValue={
                  dataList?.user?.email || "rajesh.kumar@edushala.com"
                }
                readOnly
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Mode of Tuition</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="Mode of Tuition"
                defaultValue={dataList?.modeOfTution || "Online & Offline"}
                readOnly
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup>
              <Label for="exampleEmail">Mobile Number</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="Mobile Number"
                defaultValue={dataList?.mobile || "+91 9876543210"}
                readOnly
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="exampleEmail">Alternate Mobile Number</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="Mobile Number"
                defaultValue={
                  getprofile?.data?.data?.alternateMobile || "+91 9876543211"
                }
                readOnly
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="exampleEmail">City/Address</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="City/Address"
                defaultValue={dataList?.city || "New Delhi"}
                readOnly
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="exampleEmail">state</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="City/Address"
                defaultValue={dataList?.state || "Delhi"}
                readOnly
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Gender</Label>
              <Input
                id="forType"
                name="forType"
                type="text"
                defaultValue={(PersonalList && PersonalList?.gender) || "Male"}
                readOnly
              ></Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Reffrel Code</Label>
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                }}
                id="name"
                name="question"
                placeholder="Code"
                defaultValue={dataList?.referral || "EDU12345"}
                readOnly
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Aadhar number</Label>
              <Input
                id="forType"
                name="forType"
                type="text"
                defaultValue={
                  (getprofile && getprofile?.data?.data?.aadhaar) ||
                  "XXXX-XXXX-1234"
                }
                readOnly
              ></Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup style={{ display: "flex", flexDirection: "column" }}>
              <Label for="exampleEmail">Image front</Label>
              <img
                style={{ cursor: "pointer", border: "1px solid gray" }}
                src={
                  getprofile?.data?.data?.aadhar_front?.link ||
                  "https://via.placeholder.com/70x45?text=Aadhar+Front"
                }
                height="45px"
                width="70px"
                alt="imag"
                onClick={() => {
                  const imageUrl =
                    getprofile?.data?.data?.aadhar_front?.link ||
                    "https://via.placeholder.com/400x300?text=Aadhar+Front+Image";
                  if (imageUrl) {
                    const newWindow = window.open();
                    newWindow.document.write(`
                      <html>
                        <head><title>Image Preview</title></head>
                            <body style="margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh;">
                                    <img src="${imageUrl}" alt="Aadhar Front Image" style="max-width: 100%; max-height: 100%;">
                              </body>
                             </html>`);
                    newWindow.document.close();
                  }
                }}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup style={{ display: "flex", flexDirection: "column" }}>
              <Label for="exampleEmail">Image Back</Label>
              <img
                style={{ cursor: "pointer", border: "1px solid gray" }}
                src={
                  getprofile?.data?.data?.aadhar_back?.link ||
                  "https://via.placeholder.com/70x45?text=Aadhar+Back"
                }
                height="45px"
                width="70px"
                alt="imag"
                onClick={() => {
                  const imageUrl =
                    getprofile?.data?.data?.aadhar_back?.link ||
                    "https://via.placeholder.com/400x300?text=Aadhar+Back+Image";
                  if (imageUrl) {
                    const newWindow = window.open();
                    newWindow.document.write(`
                      <html>
                        <head><title>Image Preview</title></head>
                            <body style="margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh;">
                                    <img src="${imageUrl}" alt="Aadhar Back Image" style="max-width: 100%; max-height: 100%;">
                              </body>
                             </html>`);
                    newWindow.document.close();
                  }
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default BasicDetails;
